<template>
    <div>
        <div class="row" v-if="data != null">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-info">
                        <div class="row">
                            <div class="col-md-6">
                                <h4 class="card-title ">Pelanggan Admin Sudah Bayar</h4>
                                <p class="mb-0">{{ getBulanNow() + " " +getTahunNow() }}</p>
                            </div>
                            <div class="col-md-6">
                                <p class="text-right mb-0">TOTAL</p>
                                <h4 class="card-title text-right">{{ ribu(data.total) }}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table">
                                <thead class=" text-info">
                                    <th width="20px">No.</th>
                                    <th>Keterangan</th>
                                    <th>Jumlah</th>
                                    <th>Jam</th>
                                    <th>Tanggal</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(u, index) in detail.form.data">
                                        <td>{{ index+1 }}</td>
                                        <td>{{ u.keterangan }}</td>
                                        <td>{{ ribu(u.jumlah) }}</td>
                                        <td>{{ u.jam }}</td>
                                        <td>{{ tglIndo(u.tanggal) }}</td>
                                    </tr>
                                    <tr v-if="detail.form.data == null">
                                        <td></td><td>Tidak ada Pengeluaran</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 

export default {
  name: 'Beranda',
	components: { 

	}, 
  setup() {
    const data = reactive({
        area: [],
        username: '',
        id: '',
        ppn: '',
        infoShow: null,
        total: 0
    })
    const detail = {
      form : reactive({
        data: [],
        alert: null,
        alertSuccess: null
      }),
        isNull(x) {
            var a;
            if (x == null) {
                a = 0;
            } else {
                a = x
            }
            return a;
        },
      get() {
        var datax = {
            token: 'TangTung '+sessionStorage.getItem('myToken'),
            id: data.id,
            bulan: sessionStorage.getItem('bulanIdBase'),
            tahun: sessionStorage.getItem('tahunBase')
        }
        
        var apiUrl = inter.AdminDetailPengeluaran();
        myGlobal.call(datax,apiUrl).then(x => {
            //myGlobal.loger(x);
            if (x.status == true) {
                this.form.data = x.data;
                data.total = x.pesan;
            } else {
                alert(x.pesan);
            }
        })
      }
    }
    return {
      data,
      myGlobal,
      detail
    }
  },
  mounted () {
    document.title = "Rincian Admin - Sudah Bayar";

    this.data.ppn = myGlobal.PPN();
    this.data.id = this.$route.params.id;

    this.detail.get();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.info {
  position: absolute;
  background-color: #fff;
  border: 1px solid #eee;
  border-radius: 5px;
  padding: 10px;
  z-index: 999999999;
  margin-top: -50px;
}
.tombol {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/detail/pengeluaran.vue